import { render, staticRenderFns } from "./SvgHome.vue?vue&type=template&id=7ed30346&"
import script from "./SvgHome.vue?vue&type=script&lang=js&"
export * from "./SvgHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports